import { MessageDescriptor } from 'react-intl';

export const getTranslatedText = (
  text: string,
  textCn: string,
  formatText: string | MessageDescriptor,
  locale: string,
  formatMessage: (message: MessageDescriptor) => string,
): string => {
  const title = locale === 'en-US' ? text : textCn;
  return title || (typeof formatText === 'string' ? formatMessage({ id: formatText }) : formatMessage(formatText));
};
